import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/classmate";

export default {
    /** 查询列表 */
    list: (data) => axios.get({url: `${PREFIX_URI}/list`, data: data}),

    /** 保存 */
    saveSubmit:  (data) => axios.post({url: `${PREFIX_URI}/saveSubmit`, data: data}),

    /** 删除 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),

    /** 指派工地 */
    assignSite: (siteId, classmateId) => axios.get({url: `${PREFIX_URI}/assignSite`, data: {siteId: siteId, classmateId: classmateId}}),

    /** 根据id查询 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id: id}}),

    /** 将班组移除工地 */
    deleteClassmateFromSite: (id) => axios.get({url: `${PREFIX_URI}/deleteClassmateFromSite`, data: {id: id}}),

    /** 根据班组id查询所有工人 */
    queryWorkersByClassmateId: (classmateId) => axios.get({url: `${PREFIX_URI}/queryWorkersByClassmateId`, data: {classmateId: classmateId}}),
    /** 查询所有配置 */
    queryAllAttendConfig: () => axios.get({url: `${PREFIX_URI}/queryAllAttendConfig`}),
}